import { render } from "./ModalArquivo.vue?vue&type=template&id=4df76bf3&scoped=true"
import script from "./ModalArquivo.vue?vue&type=script&lang=js"
export * from "./ModalArquivo.vue?vue&type=script&lang=js"

import "./ModalArquivo.vue?vue&type=style&index=0&id=4df76bf3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df76bf3"]])

export default __exports__